// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdp-header {
  margin-bottom: var(--spacing-regular);
}
.pdp-header .vert-title {
  font-size: var(--font-medium);
  font-weight: 600;
  color: var(--color-neutral-dark);
  margin: var(--spacing-regular) 0 0 0;
  padding: 0;
  cursor: auto;
}
.pdp-header .info-wrapper {
  display: flex;
  align-items: center;
  gap: var(--spacing-extra-small);
  margin: var(--spacing-small) 0 0 0;
}
.pdp-header .info-wrapper .vert-paragraph {
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.28px;
  color: var(--color-neutral-light-darker);
  cursor: auto;
}
.pdp-header .info-wrapper .vert-rate {
  display: flex;
}
.pdp-header .info-wrapper .vert-rate .ant-rate-star {
  font-size: 18px !important;
}
.pdp-header .info-wrapper .rate-description .vert-paragraph {
  color: var(--color-neutral-dark-darker);
}
.pdp-header .info-wrapper .description-link {
  color: var(--color-neutral-light-darker);
  text-decoration: underline;
  font-weight: 500;
  letter-spacing: 0.28px;
}
.pdp-header .info-wrapper .description-link .vert-paragraph {
  cursor: pointer;
}
.pdp-header .info-wrapper .container-favorite-product {
  display: contents;
}
.pdp-header .info-wrapper .container-favorite-product .favorite-product .vert-favorite {
  display: flex;
  align-items: baseline;
}
.pdp-header .info-wrapper .container-favorite-product .favorite-product .vert-favorite .vert-icon {
  display: inline;
}
.pdp-header .info-wrapper .container-favorite-product .favorite-product .vert-favorite .vert-icon svg {
  width: 16px;
  height: 16px;
}
.pdp-header .info-wrapper .container-favorite-product .favorite-product .vert-paragraph {
  cursor: pointer;
}
@media screen and (max-width: 480px) {
  .pdp-header {
    margin-bottom: var(--spacing-small);
  }
  .pdp-header .vert-breadcrumb .ant-breadcrumb-link a {
    font-size: 14px;
  }
  .pdp-header .vert-breadcrumb .breadcrumb-link-active a {
    font-size: 14px;
  }
  .pdp-header .vert-title {
    font-size: var(--font-paragraph);
    font-weight: 600;
    color: var(--color-neutral-dark);
    line-height: 24px;
    margin: var(--spacing-extra-small) 0 0 0;
    padding: 0;
  }
  .pdp-header .info-wrapper {
    font-weight: 400 !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: var(--spacing-small);
  }
  .pdp-header .description-link {
    display: none;
  }
  .pdp-header .separator {
    display: none;
  }
  .pdp-header .container-favorite-product {
    justify-content: center;
    display: flex !important;
  }
  .pdp-header .container-favorite-product .favorite-product .vert-paragraph {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Product/ProductHeaderStyles.less"],"names":[],"mappings":"AACA;EACI,qCAAA;AAAJ;AADA;EAIQ,6BAAA;EACA,gBAAA;EACA,gCAAA;EACA,oCAAA;EACA,UAAA;EACA,YAAA;AAAR;AATA;EAaQ,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,kCAAA;AADR;AAfA;EAmBY,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,wCAAA;EACA,YAAA;AADZ;AAtBA;EA2BY,aAAA;AAFZ;AAzBA;EA8BgB,0BAAA;AAFhB;AA5BA;EAoCgB,uCAAA;AALhB;AA/BA;EAyCY,wCAAA;EACA,0BAAA;EACA,gBAAA;EACA,sBAAA;AAPZ;AArCA;EA+CgB,eAAA;AAPhB;AAxCA;EAmDY,iBAAA;AARZ;AA3CA;EAsDoB,aAAA;EACA,qBAAA;AARpB;AA/CA;EA0DwB,eAAA;AARxB;AAlDA;EA4D4B,WAAA;EACA,YAAA;AAP5B;AAtDA;EAmEoB,eAAA;AAVpB;AAkBA;EACI;IACI,mCAAA;EAhBN;EAeE;IAMgB,eAAA;EAlBlB;EAYE;IAWgB,eAAA;EApBlB;EASE;IAiBQ,gCAAA;IACA,gBAAA;IACA,gCAAA;IACA,iBAAA;IACA,wCAAA;IACA,UAAA;EAvBV;EACE;IA0BQ,2BAAA;IACA,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,gCAAA;EAxBV;EANE;IAkCQ,aAAA;EAzBV;EATE;IAsCQ,aAAA;EA1BV;EAZE;IA0CQ,uBAAA;IACA,wBAAA;EA3BV;EAhBE;IA+CgB,aAAA;EA5BlB;AACF","sourcesContent":["// DESKTOP\n.pdp-header {\n    margin-bottom: var(--spacing-regular);\n\n    .vert-title {\n        font-size: var(--font-medium);\n        font-weight: 600;\n        color: var(--color-neutral-dark);\n        margin: var(--spacing-regular) 0 0 0;\n        padding: 0;\n        cursor: auto;\n    }\n\n    .info-wrapper {\n        display: flex;\n        align-items: center;\n        gap: var(--spacing-extra-small);\n        margin: var(--spacing-small) 0 0 0;\n\n        .vert-paragraph {\n            font-size: 14px;\n            font-weight: 500;\n            letter-spacing: 0.28px;\n            color: var(--color-neutral-light-darker);\n            cursor: auto;\n        }\n\n        .vert-rate {\n            display: flex;\n\n            .ant-rate-star {\n                font-size: 18px !important;\n            }\n        }\n\n        .rate-description {\n            .vert-paragraph {\n                color: var(--color-neutral-dark-darker);\n            }\n        }\n\n        .description-link {\n            color: var(--color-neutral-light-darker);\n            text-decoration: underline;\n            font-weight: 500;\n            letter-spacing: 0.28px;\n\n            .vert-paragraph  {\n                cursor: pointer;\n            }\n        }\n        .container-favorite-product{\n            display: contents;\n            .favorite-product {\n                .vert-favorite {\n                    display: flex;\n                    align-items: baseline;\n    \n                    .vert-icon {\n                        display: inline;\n                        svg {\n                            width: 16px;\n                            height: 16px;\n                        }\n                    }\n                }\n    \n                .vert-paragraph {\n                    cursor: pointer;\n                }\n            }\n        }\n    }\n}\n\n// MOBILE\n@media screen and (max-width: 480px) {\n    .pdp-header {\n        margin-bottom: var(--spacing-small);\n\n        .vert-breadcrumb {\n            .ant-breadcrumb-link {\n                a {\n                    font-size: 14px;\n                }\n            }\n            .breadcrumb-link-active {\n                a {\n                    font-size: 14px;\n                }\n            }\n        }\n\n        .vert-title {\n            font-size: var(--font-paragraph);\n            font-weight: 600;\n            color: var(--color-neutral-dark);\n            line-height: 24px;\n            margin: var(--spacing-extra-small) 0 0 0;\n            padding: 0;\n        }\n\n        .info-wrapper {\n            font-weight: 400 !important;\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            margin-top: var(--spacing-small)\n        }\n\n        .description-link {\n            display: none;\n        }\n\n        .separator {\n            display: none;\n        }\n\n        .container-favorite-product{\n            justify-content: center;\n            display: flex !important;\n\n            .favorite-product {\n                .vert-paragraph {\n                    display: none;\n                }\n            }\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
